exports.components = {
  "component---src-pages-header-demo-tsx": () => import("./../../../src/pages/header-demo.tsx" /* webpackChunkName: "component---src-pages-header-demo-tsx" */),
  "component---src-pages-style-guide-tsx": () => import("./../../../src/pages/style-guide.tsx" /* webpackChunkName: "component---src-pages-style-guide-tsx" */),
  "component---src-templates-story-page-tsx": () => import("./../../../src/templates/StoryPage.tsx" /* webpackChunkName: "component---src-templates-story-page-tsx" */)
}

